import React from 'react';
import BaseTabs from 'components/atoms/base-tabs';
import { Routes } from 'router/routes';
import { useTranslation } from 'react-i18next';
import { useLocation, useNavigate } from 'react-router-dom';

import s from './styles.module.scss';

import type { IBaseTab } from 'components/atoms/base-tabs';

const CallDashboardMetricsPageHeader: React.FC = () => {
  const { t } = useTranslation();
  const { pathname } = useLocation();
  const navigate = useNavigate();

  const tabs: IBaseTab<string>[] = [
    {
      key: Routes.callAgentsDashboardMetrics,
      label: t('labels.metrics'),
    },
    {
      key: Routes.callAgentsDashboardQueues,
      label: t('labels.queues'),
    },
    {
      key: Routes.callAgentsDashboardActivity,
      label: t('labels.activity'),
    },
  ];

  const handleChangeRoute = (tab: IBaseTab<string>) => {
    navigate(tab.key);
  };

  return (
    <div className={s.wrapper}>
      <h1 className={s.title}>{t('labels.callAgentsDashboard')}</h1>

      <div className={s.controls}>
        <BaseTabs
          tabs={tabs}
          type="rounded"
          size="small"
          activeKey={pathname}
          onChange={handleChangeRoute}
        />
      </div>
    </div>
  );
};

export default CallDashboardMetricsPageHeader;
